export type AttachmentEntityType = 'complaint' | 'work_order' | 'vendor' | 'technician';

export type AttachmentFileCategory =
  | 'photo_before'
  | 'photo_during'
  | 'photo_after'
  | 'document'
  | 'quotation'
  | 'report'
  | 'invoice'
  | 'other';

export interface Attachment {
  id: string;
  entity_type: AttachmentEntityType;
  entity_id: string;
  file_name: string;
  file_type: string;
  file_size: number;
  file_category: AttachmentFileCategory;
  storage_path: string;
  preview_url: string;
  thumbnail_url?: string;
  uploaded_by_user_id: string;
  uploaded_by_user_name: string;
  uploaded_at: string;
  notes?: string;
}

export interface UploadAttachmentDto {
  entity_type: AttachmentEntityType;
  entity_id: string;
  file: File;
  file_category: AttachmentFileCategory;
  notes?: string;
}

export interface AttachmentFilter {
  entity_type?: AttachmentEntityType;
  entity_id?: string;
  file_category?: AttachmentFileCategory;
}

export const FILE_CATEGORY_LABELS: Record<AttachmentFileCategory, string> = {
  photo_before: 'Before Photo',
  photo_during: 'During Photo',
  photo_after: 'After Photo',
  document: 'Document',
  quotation: 'Quotation',
  report: 'Report',
  invoice: 'Invoice',
  other: 'Other',
};

export const ALLOWED_FILE_TYPES = [
  'image/jpeg', 'image/png', 'image/webp', 'image/gif',
  'application/pdf',
  'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/plain',
];

export const MAX_FILE_SIZE_MB = 25;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
